import {useCallback, useMemo, useState} from 'react'

import {MIN_REPLY_LENGTH} from './config.js'

const useFeedbackActions = ({onReply, onReport, id}) => {
  const [showReplyForm, setShowReplyForm] = useState(false)
  const [replyText, setReplyText] = useState('')

  const isReplySubmitDisabled = useMemo(() => !replyText || replyText.trim().length < MIN_REPLY_LENGTH, [replyText])

  const handleReplyTextChange = useCallback((_, {value}) => {
    setReplyText(value)
  }, [])

  const handleReplySubmit = useCallback(() => {
    onReply({id, text: replyText})
    setShowReplyForm(false)
    setReplyText('')
  }, [id, onReply, replyText])

  const handleReplyCancel = useCallback(() => {
    setShowReplyForm(false)
    setReplyText('')
  }, [])

  const handleReportClick = useCallback(() => {
    onReport({id})
  }, [id, onReport])

  const handleReplyClick = useCallback(() => {
    setShowReplyForm(true)
  }, [])

  return {
    // state
    showReplyForm,
    replyText,

    // handlers
    handleReplyTextChange,
    handleReplySubmit,
    handleReplyCancel,
    handleReplyClick,
    handleReportClick,

    // computed props
    isReplySubmitDisabled
  }
}

export {useFeedbackActions}
